
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reviews/[make]",
      function () {
        return require("private-next-pages/reviews/[make]/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reviews/[make]"])
      });
    }
  